export const API_MODULES_LIST_REQUEST = 'API_MODULES_LIST_REQUEST';
export const API_MODULES_LIST_SUCCESS = 'API_MODULES_LIST_SUCCESS';
export const API_MODULES_LIST_FAILURE = 'API_MODULES_LIST_FAILURE';

export const modulesListRequest = payload => ({
  type: API_MODULES_LIST_REQUEST,
  payload,
});

export const modulesListSuccess = payload => ({
  type: API_MODULES_LIST_SUCCESS,
  payload,
});

export const modulesListFailure = payload => ({
  type: API_MODULES_LIST_FAILURE,
  payload,
});

const initialState = {
  selectedProgramId: null,
  isFetched: false,
  fetching: false,
  error: null,
  modules: null,
};

export function modulesListReducer(state = initialState, action) {
  console.log('getmodules 5', action)
  switch (action.type) {
    case API_MODULES_LIST_REQUEST:
      return {
        ...state,
        fetching: true,
        selectedProgramId: action.payload,
      };
    case API_MODULES_LIST_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        modules: action.payload,
      };
    case API_MODULES_LIST_FAILURE:
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
